export const mobile = `screen and (max-width: 640px)`
export const smallMobile = `screen and (max-width: 340px)`
export const tablet = `screen and (max-width: 900px)`
export const lg = `screen and (max-width: 1024px)`
export const xxl = `screen and (max-width: 1440px)`
export const XXL = `screen and (max-width: 1650px)`
